var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":_vm.absolute,"opacity":_vm.opacity,"value":_vm.loading,"z-index":_vm.zIndex}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"rotate":360,"size":100,"width":15,"value":_vm.loadingValue,"color":"#FF3700"}},[_vm._v(" "+_vm._s(_vm.loadingValue)+" ")]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }